module.exports = __webpack_public_path__ + "static/img/img_promotion_channel.ae440bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/site/img_promotion_channel.png
// module id = McQW
// module chunks = 0